// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".row-space[data-v-159d8c66] {\n  height: 2rem;\n}", ""]);
// Exports
module.exports = exports;
